import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  notificationFail,
  notificationSuccess,
} from "../slices/notificationSlice";
import { API, graphqlOperation } from "aws-amplify";
import {
  eventLatestSubstance,
  eventMapList,
  setAddMapLoader,
  setDeleteMapLoader,
  setLoader,
} from "../slices/eventMapSlice";
import {
  createEventMap,
  deleteEventMap,
  getLatestSubstanceDataMutation,
  updateEventMap,
  uploadEventMapImg,
  deleteImg,
} from "../../graphql/mutations";
import { getEventListQuery } from "../../graphql/queries";
import { userAuthDetails } from "./authThunk";
import {
  qaApi,
  prodApi,
  devApi
} from "../../aws-export";
import { ChangeServiceRequest } from "./commonThunk";

export const getEventList = createAsyncThunk(
  "getEventList",
  async (_request: any, { dispatch }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    await dispatch(
      ChangeServiceRequest({
        request:
          loginwithtype === "qa"
            ? qaApi
            : loginwithtype === "prod"
            ? prodApi
            : devApi,
      })
    );
    dispatch(setLoader(true));
    const list = (await API.graphql({
      ...graphqlOperation(getEventListQuery, _request),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; errors: any[] };
    dispatch(eventMapList(list.data));
    dispatch(setLoader(false));
    if (_request.callback) {
      _request.callback();
    }
    return list?.data?.getEventMap;
  }
);

export const createEvent = createAsyncThunk(
  "createEvent",
  async (_request: any, { dispatch }) => {
    dispatch(setAddMapLoader(true));
    const resp = (await API.graphql({
      ...graphqlOperation(createEventMap, { addEventMap: _request.request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; errors: any[] };
    if (resp.data.addEventMap.success === "true") {
      dispatch(notificationSuccess("EventMap Added Successfully"));
      dispatch(getEventList({ tenantCode: _request.request.tenantCode }));
    } else {
      dispatch(notificationFail("This Event Location is already Mapped."));
    }

    dispatch(setAddMapLoader(false));
    if (_request.callback) {
      _request.callback();
    }
  }
);

export const editEvent = createAsyncThunk(
  "editEvent",
  async (_request: any, { dispatch }) => {
    dispatch(setAddMapLoader(true));
    const editReq = {
      pk: _request.request.pk,
      flor_id: _request.request.flor_id,
      image_map_data: _request.request.image_map_data,
      image_data: _request.request.image_data,
    };
    const resp = (await API.graphql({
      ...graphqlOperation(updateEventMap, { editEventMap: editReq }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; errors: any[] };

    if (resp.data.editEventMap.success == "true") {
      dispatch(notificationSuccess("EventMap Updated Successfully"));
    } else {
      dispatch(notificationFail("Event Data not Update, Please try later"));
    }

    dispatch(setAddMapLoader(false));
    if (_request.callback) {
      _request.callback();
    }
  }
);

export const deleteEvent = createAsyncThunk(
  "deleteEvent",
  async (_request: any, { dispatch }) => {
    try {
      dispatch(setDeleteMapLoader(true));
      const resp = (await API.graphql({
        ...graphqlOperation(deleteEventMap, {
          deleteEventMap: _request.request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };
      if (resp.data.deleteEventMap.success === "true") {
        dispatch(notificationSuccess("Event Deleted Successfully"));
      } else {
        dispatch(notificationFail("Something went to wrong"));
      }
      dispatch(setDeleteMapLoader(false));
      if (_request.callback) {
        _request.callback();
      }
    } catch (err: any) {
      dispatch(setDeleteMapLoader(false));
      dispatch(notificationFail("Something went to wrong"));
    }
  }
);
export const uploadImg = createAsyncThunk(
  "uploadImg",
  async (_request: any, { dispatch }) => {
    try {
      const resp = (await API.graphql({
        ...graphqlOperation(uploadEventMapImg, {
          uploadImage: {
            file: _request.file,
            type: _request?.type,
            tenantCode: _request?.tenantCode,
            user_id: _request?.user_id,
            tenantId:_request?.tenantId,
          },
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };

      if (resp.data.uploadImage.success === "true") {
        if (_request?.setImageUploaded) {
          _request?.setImageUploaded(true);
        }
        dispatch(notificationSuccess("Image Updated Successfully"));
      } else {
        if (_request?.setFiles) {
          _request?.setFiles({
            base64: "",
            path: "",
            name: "",
            size: "",
            type: "",
          });
        }
        dispatch(notificationFail("Something went to wrong"));
      }
      if (_request.callback) {
        _request.callback();
      }
    } catch (err: any) {
      if (_request?.setFiles) {
        _request?.setFiles({
          base64: "",
          path: "",
          name: "",
          size: "",
          type: "",
        });
      }
      dispatch(notificationFail("Something went to wrong"));
    }
  }
);

export const deleteImage = createAsyncThunk(
  "deleteImage",
  async (_request: any, { dispatch }) => {
    try {
      const resp = (await API.graphql({
        ...graphqlOperation(deleteImg, {
          deleteimage: { user_id: _request?.user_id },
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };

      if (resp?.data?.deleteimage?.success === "true") {
        dispatch(notificationSuccess("Image deleted successfully"));
        if (_request?.setFiles) {
          _request?.setFiles({
            base64: "",
            path: "",
            name: "",
            size: "",
            type: "",
          });
        }
        if (_request?.setProfileURL) {
          _request?.setProfileURL(null);
        }
      } else {
        dispatch(notificationFail("Something went to wrong"));
      }
      if (_request?.callback) {
        _request.callback();
      }
    } catch (err: any) {
      dispatch(notificationFail("Something went to wrong"));
    }
  }
);

export const getLatestSubstanceData = createAsyncThunk(
  "getLatestSubstanceData",
  async (_request: any, { dispatch }) => {
    try {
      const resp = (await API.graphql({
        ...graphqlOperation(getLatestSubstanceDataMutation, {
          devices: _request.devices,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };
      if (resp.data.getLatestSubstanceData) {
        dispatch(eventLatestSubstance(resp.data.getLatestSubstanceData));
      }
    } catch (err: any) {
      console.error(err);
    }
  }
);
